<template>
    <v-dialog
      v-model="show"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Atualizar conjunto
        </v-card-title>

        <v-card-text class="py-5">
          <v-select
            filled
            dense
            color="primary"
            label="Status"
            v-model="status"
            :items="statusOptions"
            item-text="name"
            item-value="id"
            :rules="[(v) => (v === 0 || !!v) || 'Preencha o campo']"
          >
          </v-select>

          <engine-selector
            :engines="engines"
            :onChange="handleEngineChange"
            :allow-creation="false"
            :initial-value="currentEngineName"
            label="Selecione o motor"
          />

          <v-card-actions>
            <v-btn
              color="primary"
              @click="handleConfirm"
              :disabled="!Boolean(engineName)"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import { STATUS } from '@/module/pump_moto/domain/model/pump_moto';

import EngineSelector from './EngineSelector.vue';

export default {
  name: 'UpdateModal',
  components: {
    EngineSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true,
      default: () => null
    },
    engines: {
      type: [],
      default: []
    },
    currentEngineName: {
      type: String,
      default: ''
    },
    currentStatus: {
      type: Number,
      default: STATUS.ACTIVE
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  },
  data: function() {
    return {
      statusOptions: [{ name: "Ativo", id: STATUS.ACTIVE }, { name: "Inativo", id: STATUS.INACTIVE }],
      engineName: this.currentEngineName,
      status: this.currentStatus
    }
  },
  methods: {
    handleConfirm() {
      this.onConfirm({ engineName: this.engineName, status: this.status })
    },
    handleEngineChange(name) {
      this.engineName = name
    }
  },
  watch: {
    currentEngineName(v) {
      this.engineName = v
    },
    currentStatus(v) {
      this.status = this.currentStatus
    }
  }
}
</script>
